export class SortDataCatalogBy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "DataCatalogSortField",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "SortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SortDataCatalogBy.attributeTypeMap;
    }
    constructor() {
    }
}
